
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function Pricing() {
  const { t } = useTranslation();
  
  const plans = [
    {
      name: t('Basic'),
      price: t('¥14,000'),
      period: '/月',
      description: t('Perfect for beginners'),
      features: [
        t('2 classes per month'),
        t('Access to basic materials'),
        t('Community forum access')
      ],
      popular: false
    },
    {
      name: t('Pro'),
      price: t('¥28,000'),
      period: '/月',
      description: t('Most popular choice'),
      features: [
        t('8 classes per month'),
        t('All course materials'),
        t('1-on-1 sessions available'),
        t('Priority support')
      ],
      popular: true
    },
    {
      name: t('Elite'),
      price: t('Contact for pricing'),
      period: '',
      description: t('For serious learners'),
      features: [
        t('Unlimited classes'),
        t('Personal learning plan'),
        t('Weekly 1-on-1 coaching'),
        t('Exclusive content access')
      ],
      popular: false
    }
  ];
  
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('Choose Your Plan')}
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <Card 
              key={index} 
              hover 
              className={`p-8 text-center relative ${plan.popular ? 'ring-2 ring-blue-600 scale-105' : ''}`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                    {t('Most popular choice')}
                  </span>
                </div>
              )}
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {plan.name}
              </h3>
              
              <div className="mb-6">
                <span className="text-4xl font-bold text-gray-900">
                  {plan.price}
                </span>
                <span className="text-gray-600">
                  {plan.period}
                </span>
              </div>
              
              <p className="text-gray-600 mb-8">
                {plan.description}
              </p>
              
              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center justify-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                className={`w-full whitespace-nowrap ${plan.popular ? 'bg-blue-600 hover:bg-blue-700' : ''}`}
                variant={plan.popular ? 'primary' : 'outline'}
              >
                {t('Get Started')}
              </Button>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            ※ 月8回コースは月内にレッスンを消化できなかった場合、以降3ヶ月間繰越可能
          </p>
          <p className="text-gray-600">
            すべてのクラスはZoomまたはGoogle Meetでオンライン開催
          </p>
        </div>
      </div>
    </section>
  );
}
